 const EXPORT_DATA = {
   CONTACT_SALE: "export-data/contact-sale-submissions",
 };

export default EXPORT_DATA;